// extracted by mini-css-extract-plugin
export default {"button":"SingleChoiceSelectionButtonNotification_button__X4c2T","buttonSelected":"SingleChoiceSelectionButtonNotification_buttonSelected__h7W3d"};